import { render, staticRenderFns } from "./ConfirmationSummaryProperty.vue?vue&type=template&id=5a38cf8c&scoped=true&"
import script from "./ConfirmationSummaryProperty.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSummaryProperty.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationSummaryProperty.vue?vue&type=style&index=0&id=5a38cf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a38cf8c",
  null
  
)

export default component.exports